var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sc-ed99b3fd-0 jrAENr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#080E11",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3487_21030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1179 14.4038L16.0023 10.521L19.8882 14.4069L22.1471 12.1464L16.0023 6L9.85742 12.1449L12.1179 14.4038Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16.0008L8.25891 13.7403L10.5194 16.0008L8.25891 18.2597L6 16.0008Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1179 17.5962L16.0023 21.4806L19.8882 17.5947L22.1487 19.852L16.0039 25.9984L9.85742 19.8567L12.1179 17.5962Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4807 16.0008L23.7396 13.7403L26.0001 15.9992L23.7396 18.2613L21.4807 16.0008Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2944 15.9992L16.0023 13.7056L14.3073 15.4005L14.1114 15.5948L13.7102 15.9961L16.0023 18.2866L18.2944 16.0008V15.9992Z",
    fill: "#F3BA2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3487_21030"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 20,
    transform: "translate(6 6)",
    width: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.14ea4d167d849d039b2c98b1ed65d91e.svg";
export { ForwardRef as ReactComponent };